import { LuChevronDown } from 'react-icons/lu'
import {
  Box,
  HStack,
  Text,
  Table,
  Thead,
  Tbody,
  Image,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Button,
  useDisclosure,
  Spinner,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Icon,
} from '@chakra-ui/react'

const TableList = ({list,getPage}) => {


	return (


		<TableContainer width="100%">
		            <Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
		              <Thead >
		                <Tr>
		               	 
		                  <Th>Account Name</Th>
		                  <Th>Method</Th>
		                  <Th>End Point </Th>
		                 
		                 
		               
		    							<Th>Status</Th>
											<Th></Th>

		                  

		                  
		                </Tr>
		              </Thead>

		              <Tbody fontSize="14px">
		              			{list?.map((rs,index)=>{

		              			const configData = JSON.parse(rs.api_config)

		              				return(
		              					<>
		              						<Tr> 	
					                            <Td>{rs.account_name}</Td>
					                            <Td>{configData.method}</Td>
					                            <Td sx={{
													whiteSpace: 'normal',
													wordBreak: 'break-word',
													minWidth: '400px',
													maxWidth: '40%',
													p: 4,
													verticalAlign: 'top'
												}}>{configData.url}</Td>
					                           
					                            <Td>{rs.status_id === 1 ? "Active" : "InActive"}</Td>
					                           
					                            

					                            
					                            
					                          	<Td style={{color:"#0000EE"}}>
						                            <Menu>
						                              <MenuButton fontSize="14px" >
						                              Action
						                                
						                                  <Icon as={LuChevronDown} />
						                              </MenuButton>

						                              <MenuList  style={{minWidth:"20px",border:"1px solid #CCCCCC"}}>
						                                <MenuItem  h="16px" fontSize="12px" onClick={()=> getPage('editSms','1',rs)} >Edit</MenuItem>						                                
						                              </MenuList>
						                            </Menu>
				                           		</Td>
					                      
				                            </Tr>
		              					</>
		              				)
		              			})}
				          		
				         

			             
		                           	
			                    
		            
		              </Tbody>
		             
		              
		            </Table>
		            
		          </TableContainer>

	)
}

export default TableList